import { render, staticRenderFns } from "./psSettlementTask.vue?vue&type=template&id=7173037e&scoped=true"
import script from "./psSettlementTask.vue?vue&type=script&lang=js"
export * from "./psSettlementTask.vue?vue&type=script&lang=js"
import style0 from "./psSettlementTask.vue?vue&type=style&index=0&id=7173037e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7173037e",
  null
  
)

export default component.exports